function getAtmFee(transferAmount: number = 0, feePercent: number = 0, minFeeAmount: number = 100) {
  if (!transferAmount || !feePercent) {
    return { feeAmount: 0, transferAfterFeeAmount: 0, transferWithFeeAmount: 0 };
  }

  let feeAmount = Math.floor((transferAmount * feePercent) / 100);

  if (feeAmount < minFeeAmount) {
    feeAmount = minFeeAmount;
  }

  const transferAfterFeeAmount = Math.max(transferAmount - feeAmount, 0);

  return { feeAmount, transferAfterFeeAmount, transferWithFeeAmount: transferAmount + feeAmount };
}

export function getFeeData({
  balance,
  feePercent,
  transferAmount,
  transferLimit,
  minFeeAmount = 100,
}: {
  balance: number;
  feePercent: number;
  transferAmount: number;
  transferLimit: number;
  minFeeAmount?: number;
}) {
  const maxAmountBeforeFee = Math.floor((balance * 100) / (100 + feePercent));
  const { feeAmount, transferAfterFeeAmount, transferWithFeeAmount } = getAtmFee(
    transferAmount,
    feePercent,
    minFeeAmount,
  );

  return {
    maxAmountBeforeFee,
    transferLimit,
    feeAmount,
    transferAfterFeeAmount,
    transferWithFeeAmount,
  };
}
